<script>
  import { _ } from '@sveltia/i18n';
  import { Icon, MenuButton } from '@sveltia/ui';

  import AccountMenu from '$lib/components/global/toolbar/items/account-menu.svelte';
  import { backendName } from '$lib/services/backends';

  /** @type {MenuButton | undefined} */
  let menuButton = $state();

  const isLocalRepo = $derived($backendName === 'local');
</script>

<div role="none" class="wrapper">
  <MenuButton
    variant="ghost"
    iconic={!isLocalRepo}
    label={isLocalRepo ? _('local_workflow.indicator') : undefined}
    popupPosition="bottom-right"
    aria-label={_('show_account_menu')}
    bind:this={menuButton}
  >
    {#snippet endIcon()}
      {#if isLocalRepo}
        <Icon name="arrow_drop_down" class="small-arrow" />
      {:else}
        <Icon name="account_circle" />
      {/if}
    {/snippet}
    {#snippet popup()}
      <AccountMenu {menuButton} />
    {/snippet}
  </MenuButton>
</div>

<style>
  .wrapper {
    display: contents;
  }
</style>
